module.exports = __webpack_public_path__ + "static/media/rgi_logo1.d988265d.png";